import React from 'react';

function SecuritySettings() {
    return (
        <div className='my-3'>
            <form className="grid grid-cols-1 md:grid-cols-3 gap-4 w-full md:w-3/4">   
                <div className="relative">
                    <label htmlFor="actualPassword" className='mb-2 text-sm'>Current Password</label>
                    <input id="actualPassword" type="password" 
                        className="bg-white border-[#C7DDDA] border-[2px] text-gray-900 text-sm block w-full p-3 rounded-[16px] px-4 focus:outline-none focus:ring-1 focus:ring-[#C7DDDA]" 
                        placeholder="Enter current password" required 
                    />
                </div>
                <div className="relative">
                    <label htmlFor="newPassword" className='mb-2 text-sm'>New Password</label>
                    <input id="newPassword" type="password" 
                        className="bg-white border-[#C7DDDA] border-[2px] text-gray-900 text-sm block w-full p-3 rounded-[16px] px-4 focus:outline-none focus:ring-1 focus:ring-[#C7DDDA]" 
                        placeholder="Enter new password" required 
                    />
                </div>
                <div className="relative">
                    <label htmlFor="confirmNewPassword" className='mb-2 text-sm'>Confirm New Password</label>
                    <input id="confirmNewPassword" type="password" 
                        className="bg-white border-[#C7DDDA] border-[2px] text-gray-900 text-sm block w-full p-3 rounded-[16px] px-4 focus:outline-none focus:ring-1 focus:ring-[#C7DDDA]" 
                        placeholder="Confirm new password" required 
                    />
                </div>
                <button type='submit' className="rounded-lg p-3 bg-[#90BCB5] w-1/3">
                    <span className="text-white text-base font-medium">Save</span>
                </button>
            </form>
        </div>
    );
}

export default SecuritySettings;
